import React, { useEffect, useState } from 'react';

import { Switch } from '@mantine/core';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Field } from 'redux-form';
import Button from '../../elements/Button/Button';
import MultiSelectCheckboxes from '../../fields/Select/MultiSelectCheckboxes';
import Select from '../../fields/SelectBox';
import { fetchCities, fetchDistricts, fetchProvinces, fetchVillages } from '../../layouts/PageBase/actions';
import { fieldsProps } from './schema';
import styles from './styles.scoped.css';
import { mapping, mappingById } from '../../../utils/format';
import { useDebounce } from 'use-debounce';

// import Switch from '../../fields/Switch/Switch';


export default function Component({
  dataDetailUser,
  handleSubmit,
  change,
  handleClose,
  // data = {}
}) {
  const dispatch = useDispatch();
  const [search, setSearch] = useState('');
  const debouncedSearch = useDebounce(search, 500);
  const { activePeriod, regional, province, city, district, village } = fieldsProps;
  const { values } = useSelector((state) => state.form.formSettingManualTransactionBulk);
  const {
    dataRegionals,
    dataProvinces,
    dataCities,
    dataDistricts,
    dataVillages
  } = useSelector((s) => s.pageBase);

  const {
    isLoadingSubmitAutoApprove
  } = useSelector((s) => s.manualLoggingActivation);

  const onSubmit = async (e) => {
    e.preventDefault();
    const prov = values.province?.length > 0 ? { provinceId: mapping(values.province) } : [];
    const city = values.city?.length > 0 ? { cityId: mapping(values.city) } : [];
    const district = values.district?.length ? { districtId: mapping(values.district) } : [];
    const village = values.village?.length ? { villageId: mapping(values.village) } : [];

    const params = {
      regional: values.regional,
      ...prov,
      ...city,
      ...district,
      ...village,
      activePeriod: values.activePeriod,
      status: values.status ? 'ACTIVE' : 'NON_ACTIVE'
    };
    handleSubmit(params);
  };

  const handelAdministrativeArea = (name, selected) => {
    let id = [];
    if (name !== 'regional') {
      id = selected?.map((val) => {
        return val.value;
      });
    }

    if (name === 'regional') {
      dispatch(fetchProvinces({ regional: JSON.stringify([selected]) }));
      dispatch(fetchCities({ regional: JSON.stringify([selected]) }));
      dispatch(fetchDistricts({ regional: JSON.stringify([selected]) }));
      dispatch(fetchVillages({ regional: JSON.stringify([selected]) }));
      change('province', []);
      change('city', []);
      change('district', []);
      change('village', []);
    }

    if (name === 'province') {
      dispatch(fetchCities({ provinceId: JSON.stringify(mappingById(id)) }));
      dispatch(fetchDistricts({ provinceId: JSON.stringify(mappingById(id)) }));
      dispatch(fetchVillages({ provinceId: JSON.stringify(mappingById(id)) }));
      change('city', []);
      change('district', []);
      change('village', []);
    }

    if (name === 'city') {
      dispatch(fetchDistricts({
        provinceId: JSON.stringify(mapping(values.province)),
        cityId: JSON.stringify(mappingById(id))
      }));
      dispatch(fetchVillages({
        provinceId: JSON.stringify(mapping(values.province)),
        cityId: JSON.stringify(mappingById(id))
      }));
      change('district', []);
      change('village', []);
    }

    if (name === 'district') {
      dispatch(fetchVillages({
        provinceId: JSON.stringify(mapping(values.province)),
        cityId: JSON.stringify(mapping(values.city)),
        districtId: JSON.stringify(mappingById(id))
      }));
      change('village', []);
    }
  };

  const handleChange = (name, selected) => {
    change(name, selected);
    handelAdministrativeArea(name, selected);
  };

  useEffect(() => {
    dispatch(fetchProvinces({ regional: JSON.stringify([values.regional]) }));
    dispatch(fetchCities({ regional: JSON.stringify([values.regional]) }));
    dispatch(fetchDistricts({ regional: JSON.stringify([values.regional]) }));
    dispatch(fetchVillages({ regional: JSON.stringify([values.regional]) }));
  }, [values.regional]);

  const handleSearch = (name, e) => {
    setSearch({ name, search: e.target.value });
  };

  useEffect(() => {
    const params = {
      regional: JSON.stringify([values.regional]),
      provinceId: JSON.stringify(mapping(values.province)),
      search: debouncedSearch[0].search
    };

    if (debouncedSearch[0].name === 'city') {
      dispatch(fetchCities(params));
    }

    if (debouncedSearch[0].name === 'district') {
      dispatch(fetchDistricts({
        ...params,
        cityId: JSON.stringify(mapping(values.city)),
      }));
    }

    if (debouncedSearch[0].name === 'village') {
      dispatch(fetchVillages({
        ...params,
        cityId: JSON.stringify(mapping(values.city)),
        districtId: JSON.stringify(mapping(values.district)),
      }));
    }
  }, debouncedSearch);


  return (
    <form className={styles.form} encType="multipart/form-data" onSubmit={onSubmit}>
      <Field
        component={Select}
        data={dataDetailUser.regionalId ?
          dataRegionals.filter((val) => val.value === dataDetailUser.regionalId)
          : dataRegionals}
        inputProps={regional}
        name={regional.name}
        onChangeSelect={(e) => handleChange('regional', e)}
        required={true}
        searchable
      />
      <Field
        component={MultiSelectCheckboxes}
        data={dataProvinces}
        handleChange={handleChange}
        inputProps={province}
        label={province.label}
        name={province.name}
        optionSelected={values?.province || []}
      />
      <Field
        component={MultiSelectCheckboxes}
        data={dataCities}
        handleChange={handleChange}
        handleOnKeyUp={handleSearch}
        inputProps={city}
        label={city.label}
        name={city.name}
        optionSelected={values?.city || []}
      />
      <Field
        component={MultiSelectCheckboxes}
        data={dataDistricts}
        handleChange={handleChange}
        handleOnKeyUp={handleSearch}
        inputProps={district}
        label={district.label}
        name={district.name}
        optionSelected={values?.district || []}
      />
      <Field
        component={MultiSelectCheckboxes}
        data={dataVillages}
        handleChange={handleChange}
        handleOnKeyUp={handleSearch}
        inputProps={village}
        label={village.label}
        name={village.name}
        optionSelected={values?.village || []}
      />
      <Field
        component={Select}
        data={activePeriod.data}
        inputProps={activePeriod}
        name={activePeriod.name}
        required={true}
      />
      <label>Status</label><span className={styles.isRequired} />
      <Switch
        checked={values?.status}
        color="green"
        labelPosition={'left'}
        offLabel={'Tidak Aktif'}
        onClick={() => change('status', !values.status)}
        onLabel={'Aktif'}
        size="lg" />
      <div className={styles.actions}>
        <Button
          //   disabled={isLoadingSubmissionProses}
          onClick={handleClose}
          style="outlined"
          type="button"
        >
          Batal
        </Button>
        <Button
          disabled={(values?.regional === '' || values.activePeriod === '') || isLoadingSubmitAutoApprove}
          style={'blue'}
          type="submit"
        >
          Ubah Pengaturan
        </Button>
      </div>
    </form>
  );
}
Component.propTypes = {
  change: PropTypes.func.isRequired,
  data: PropTypes.object,
  dataDetailUser: PropTypes.object,
  handleClose: PropTypes.func,
  handleSubmit: PropTypes.func,
};

